import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.ticketing.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-ticketing-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.ticketing.list/view.scss */
/* src/app/portal.gsdcadmin.ticketing.list/view.scss: no such file or directory */`],
})
export class PortalGsdcadminTicketingListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public tickets: any = [];

    public searchTerm: any = "";

    public pagination: any = {
        page: 1,
        end: 1,
        start: 1,
    };
    public total = 0;

    public mode: any = "";

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', "/landing");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("search", { mode: this.mode, text:this.searchTerm, page:this.pagination.page });
        if (code != 200) return await this.service.alert.error("Error!");
        this.tickets = data.rows;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.load();
    }
}

export default PortalGsdcadminTicketingListComponent;